import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App.js';
import reportWebVitals from './reportWebVitals';
import { Platform } from 'react-native';
import {Provider as PaperProvider, MD3LightTheme as PaperDefaultTheme} from 'react-native-paper';
import { ThemeProvider, createTheme } from '@mui/material';

const root = ReactDOM.createRoot(document.getElementById('root'));

const CombinedDefaultTheme = {
  ...PaperDefaultTheme,
  fonts: {
    fontFamily: "SFPRODISPLAYBOLD"
  }
};
const themeMUI = createTheme({
  typography: {
    fontFamily: 'SFPRODISPLAYBOLD',
  },
});

root.render(
  <React.StrictMode>
    <PaperProvider theme={CombinedDefaultTheme}>
      <ThemeProvider theme={themeMUI}>
          <React.Fragment>
            {Platform.OS === 'web' ? (
              <style type="text/css">{`
                @font-face {
                  font-family: 'MaterialCommunityIcons';
                  src: url(${require('react-native-vector-icons/Fonts/MaterialCommunityIcons.ttf')}) format('truetype');
                }
              `}</style>
            ) : null}
            <App />
          </React.Fragment>
        </ThemeProvider>
    </PaperProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
